import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply saved theme to body and html before first render to prevent flash
const savedTheme = localStorage.getItem("theme");
const isDark = savedTheme ? savedTheme === "true" : true;
document.body.classList.add(isDark ? "dark-theme" : "light-theme");
document.body.classList.remove(isDark ? "light-theme" : "dark-theme");
document.documentElement.classList.add(isDark ? "dark-theme" : "light-theme");
document.documentElement.classList.remove(isDark ? "light-theme" : "dark-theme");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
